// Single source of truth for the hamburger menu's course/church/support/about sections.
// Shared by SiteHeader.jsx and LandingNavbar.jsx to prevent the two menus from drifting apart.
import { Users, Footprints, Bird, HeartHandshake, Route, Baby, Backpack, Church, MapPin, MessageCircle, BookText, Heart, DollarSign, Newspaper, HelpCircle, Clock3, GraduationCap, LayoutGrid } from 'lucide-react';

export const MENU_SECTIONS = [
  {
    key: 'addicts',
    title: 'Courses for Addicts',
    testId: 'menu-section-courses-addicts',
    links: [
      { testId: 'menu-course-walking-it-out', icon: Footprints, label: 'Walking It Out', sublabel: '8 weeks · start here', path: '/courses/walking-it-out-addict' },
      { testId: 'menu-course-still-walking-it-out', icon: Route, label: 'Still Walking It Out', sublabel: '17 weeks · next step', path: '/courses/still-walking-it-out-addict' },
      { testId: 'menu-course-walking-in-freedom', icon: Bird, label: 'Walking in Freedom', sublabel: '12 weeks · long-term', path: '/courses/walking-in-freedom' },
    ]
  },
  {
    key: 'family',
    title: 'Courses for Family',
    testId: 'menu-section-courses-family',
    links: [
      { testId: 'menu-course-walking-it-out-family', icon: Footprints, label: 'Walking It Out', sublabel: 'for the family · 8 weeks', path: '/courses/walking-it-out-family' },
      { testId: 'menu-course-still-walking-it-out-family', icon: Route, label: 'Still Walking It Out', sublabel: 'for the family · 17 weeks', path: '/courses/still-walking-it-out-family' },
      { testId: 'menu-course-still-standing', icon: HeartHandshake, label: 'Still Standing', sublabel: 'spouses', path: '/course/still-standing' },
      { testId: 'menu-course-still-watching-the-road', icon: Route, label: 'Still Watching the Road', sublabel: 'parents', path: '/course/still-watching-the-road' },
      { testId: 'menu-course-children-of-addiction', icon: Baby, label: 'Children of Addiction', sublabel: 'ages 4-17', path: '/course/children-of-addiction' },
      { testId: 'menu-course-the-weight-you-grew-up-with', icon: Backpack, label: 'The Weight You Grew Up With', sublabel: 'adult children', path: '/course/the-weight-you-grew-up-with' },
    ]
  },
  {
    key: 'churches',
    title: 'Churches & Organizations',
    testId: 'menu-section-churches',
    links: [
      { icon: Church, label: 'Church/Rehab Licensing', path: '/for-organizations' },
      { testId: 'menu-org-membership-link', icon: Users, label: 'Church & Rehab Memberships', sublabel: 'seats for your people · from $49/mo', path: '/org/signup' },
      { testId: 'menu-licensees-directory-link', icon: MapPin, label: 'Licensees Directory', path: '/licensees-directory' },
      { testId: 'menu-recovery-to-service-link', icon: GraduationCap, label: 'Recovery to Service Training', path: '/recovery-to-service' },
    ]
  },
  {
    key: 'support',
    title: 'Community & Support',
    testId: 'menu-section-support',
    links: [
      { testId: 'menu-first24-link', icon: Clock3, label: 'Free Guide: First 24 Hours', path: '/first-24-hours' },
      { testId: 'menu-real-stories-link', icon: MessageCircle, label: 'Real Stories', path: '/#testimonials', isRealStories: true },
    ]
  },
  {
    key: 'about',
    title: 'About',
    testId: 'menu-section-about',
    links: [
      { testId: 'menu-what-we-offer-link', icon: LayoutGrid, label: 'What We Offer', sublabel: 'individuals · families · churches · R2S', path: '/what-we-offer' },
      { icon: BookText, label: 'Our Story', path: '/founder-story' },
      { testId: 'menu-what-we-believe-link', icon: Heart, label: 'What We Believe', path: '/what-we-believe' },
      { icon: DollarSign, label: 'Member Prices', path: '/pricing' },
      { testId: 'menu-blog-link', icon: Newspaper, label: 'Blog', path: '/blog' },
      { icon: HelpCircle, label: 'FAQs', path: '/faq' },
    ]
  }
];

export default MENU_SECTIONS;

